import React from 'react';
import { StaticQuery, graphql } from 'gatsby';

import { Navigation } from './src/index';

const query = graphql`
  query {
    prismic {
      navigation(lang: "en-us", uid: "site-navigation") {
        announcement_link {
          ... on PRISMIC__ExternalLink {
          _linkType
            url
          }
        }
        announcement_pill_text
        announcement_text
        rel
        bottom_link {
          ... on PRISMIC__ExternalLink {
            _linkType
            url
          }
        }
        bottom_link_text
        brand_name
        community_mega_menu_community {
          community_image
          community_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          community_subtitle
          community_title
          community_tracking_name
          community_tracking_category
        }
        community_mega_menu_community_title
        community_mega_menu_featured_articles {
          featured_articles_image
          featured_articles_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          featured_articles_text
          featured_articles_tracking_name
          featured_articles_tracking_category
        }
        community_mega_menu_featured_title
        community_mega_menu_get_involved {
          get_involved_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          get_involved_text
          get_involved_tracking_name
          get_involved_tracking_category
        }
        community_mega_menu_get_involved_title
        navigation_image
        primary_navigation_end_links {
          primary_navigation_end_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          primary_navigation_end_link_text
        }
        primary_navigation_links {
          primary_navigation_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          primary_navigation_text
          primary_tracking_name
          primary_tracking_category
        }
        products_mega_menu_featured {
          featured_product_image
          featured_product_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          featured_product_subtitle
          featured_product_title
          featured_tracking_name
          featured_tracking_category
        }
        products_mega_menu_secondary {
          secondary_image
          secondary_link_1 {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          secondary_link_2 {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          secondary_link_3 {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          secondary_link_4 {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          secondary_link_5 {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          secondary_link_6 {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          secondary_text_1
          secondary_text_2
          secondary_text_3
          secondary_text_4
          secondary_text_5
          secondary_text_6
          secondary_title
          secondary_tracking_name_1
          secondary_tracking_category_1
          secondary_tracking_name_2
          secondary_tracking_category_2
          secondary_tracking_name_3
          secondary_tracking_category_3
          secondary_tracking_name_4
          secondary_tracking_category_4
          secondary_tracking_name_5
          secondary_tracking_category_5
          secondary_tracking_name_6
          secondary_tracking_category_6
        }
        products_mega_menu_title
        solutions_mega_menu {
          solutions_image
          solutions_link {
            ... on PRISMIC__ExternalLink {
              url
              _linkType
            }
          }
          solutions_title
          solutions_subtitle
          solutions_tracking_name
          solutions_tracking_category
        }
        solutions_bottom_link {
          ... on PRISMIC__ExternalLink {
            _linkType
            url
          }
        }
        solutions_bottom_link_text
        tiny_navigation_links {
          tiny_navigation_link {
            ... on PRISMIC__ExternalLink {
              _linkType
              url
            }
          }
          tiny_navigation_path
          tiny_navigation_text
          tiny_link_rel
        }
      }
    }
  }
`;

const Navbar = location => (
  <>
    <StaticQuery query={`${query}`} render={data => <Navigation location={location} data={data} />} />
  </>
);

export default Navbar;
